module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Veuillez ouvrir une session Sephora',
        beautyInsiderAlt: 'Beauty Insider'
    };

    return resources[label];
};
